import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginService} from '../login.service';
import {MatDialog} from '@angular/material/dialog';
import {Session} from '../../domain/session';
import {PopupDialogBase} from '../../component/popup-dialog-base';
import {MessageService} from '../../component/message.service';
import {LoginResponse} from '../../domain/login-response';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent extends PopupDialogBase {
  @Input() isInDialog = false;
  @Output() loginSuccessful = new EventEmitter<boolean>();

  loginForm: UntypedFormGroup;
  error: string;
  loggingIn: boolean;

  constructor(
    formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private session: Session,
    private dialog: MatDialog,
    private router: Router,
    private messageService: MessageService
  ) {
    super();

    this.loginForm = formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      company: ['', Validators.required]
    });
  }

  ngOnInit() {
  }

  cancel() {
    if (this.isInDialog) {
      this.dialog.closeAll();
    }

    if (this.route.snapshot.url.toString().includes('admin')) {
      this.router.navigate(['']);
    }
  }

  onLogin() {
    if (this.loginForm.valid) {
      const parameters = {
        Username: this.loginForm.value.username,
        Password: this.loginForm.value.password,
        Company: this.loginForm.value.company
      };

      this.loggingIn = true;
      this.error = '';

      this.login(parameters)
        .then(() => {
          this.loginSuccessful.emit();

          this.router.navigate(['admin']);

          this.close();
        })
        .catch(() => {
          this.messageService.showErrorSnackBar('Feil brukernavn eller passord');
          this.session.reset();
        })
        .finally(() => this.loggingIn = false);
    }
  }

  async login(parameters: any) {
    let loginResponse: LoginResponse = await this.loginService.login(parameters);

    if (loginResponse.UserType != 'WebAdmin' && loginResponse.UserType != 'Admin') {
      throw new Error('Brukeren har ikke tilgang til å logge på');
    }

    this.session.setUserProperties(
      loginResponse.UserFullName,
      loginResponse.CompanyId,
      loginResponse.CompanyName,
      loginResponse.UserId,
      loginResponse.UserType
    );

    this.session.setAllowUserMaintenance(loginResponse.AllowUserMaintenanceInWeb);
    this.session.setShowAssignOrderToUser(loginResponse.ShowAssignOrderToUserInWeb);
    this.session.setShowAssignShipentToCarrier(loginResponse.ShowAssignShipmentToCarrierInWeb);
    this.session.setEnableShipmentLabelPrinting(loginResponse.EnableShipmentLabelPrintingInWeb);

    this.session.setTokens(loginResponse.AccessToken, loginResponse.RefreshToken)

    let departmentResponse = await this.loginService.getDepartments();

    if (departmentResponse.Departments != null) {
      this.session.setDepartments(departmentResponse.Departments)
    }

    let carriersResponse = await this.loginService.getCarriers();

    if (carriersResponse.Carriers != null) {
      this.session.setCarriers(carriersResponse.Carriers);
    }
  }
}
